<div class="container">
  <h1 i18n>
    Política de cancelación de órdenes de compra y devolución parcial y/o
    total de fondos:
  </h1>
  <div class="dakkini-card mt-4">
    <p class="m-0 fs-14px" i18n>
      En <strong>{{this.companyName}}</strong>, nos esforzamos por brindar una experiencia de compra
      satisfactoria a todos nuestros clientes. Sin embargo, entendemos que
      pueden surgir circunstancias imprevistas que requieran la cancelación de
      una orden de compra o la solicitud de una devolución parcial y/o total de
      fondos. Por lo tanto, hemos establecido la siguiente política:
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>Cancelación de órdenes de compra:</strong>
    </p>
    <p class="m-0 fs-14px" i18n>
      Una vez que se procesa el pago de una orden de compra por medio de la
      plataforma de {{this.companyName}}, no se podrá llevar a cabo ninguna cancelación de la
      orden, sin importar la razón. Esto incluye situaciones en las que la orden
      aún no ha sido enviada y/o entregada al consumidor final. La única
      excepción a esta política será si la organización es responsable de algún
      error en el procesamiento de la orden, en cuyo caso, se tomarán las
      medidas necesarias para resolver el problema.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>Devolución parcial y/o total de fondos:</strong>
    </p>
    <p class="m-0 fs-14px" i18n>
      En {{this.companyName}}, reconocemos que los clientes pueden desear solicitar una
      devolución parcial o total de fondos por diversas razones. Sin embargo, no
      procederemos con ninguna devolución a menos que se impute alguna
      responsabilidad de la organización. El consumidor es responsable de
      verificar que su orden se encuentre correcta con base a la conversación
      que el usuario (cliente) entabló con su coach.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      Si el cliente ha recibido un producto que no cumple con las
      especificaciones acordadas o ha experimentado algún problema relacionado
      con la calidad, se le solicitará que nos contacte de inmediato para que
      podamos tomar las medidas necesarias para resolver el problema.
    </p>
    <p class="m-0 fs-14px" i18n>
      Cualquier controversia derivada de la presente política será resuelta
      mediante el correo electrónico {{this.contactEmail}}.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      {{this.companyName}} agradece la confianza depositada por sus usuarios y reitera su
      compromiso de continuar trabajando para ofrecer una experiencia de compra
      satisfactoria y de calidad.
    </p>
    <p class="m-0 mt-4 fs-14px" i18n>
      <strong>Última modificación:</strong> 03 de enero de 2023
    </p>
  </div>
</div>